/* React base component */
import { Component } from "react"

/* Component Logo */
class Logo extends Component {

    render = () => {
        const size = this.props.size || 36
        return (
            <img
                src="/logo.png"
                alt="Bookify"
                className={`logo-img ${this.props.className || ""}`}
                style={{ height: size, width: "auto", display: "block" }}
            />
        )
    }
}

/* Export */
export default Logo
